export const getVisibleColumns = (columns) => {
  return columns.reduce((a, c) => {
    if (c.visible) {
      a.push(c.dataKey);
    }
    return a;
  }, []);
};
